import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { MoveInstallationInFolderReqData } from "./MoveInstallationInFolderReqData";

const ENDPOINT = "/device/tree";

export class MoveInstallationInFolderCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "put";
    params: MoveInstallationInFolderReqData;

    constructor(params: MoveInstallationInFolderReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.params);
        return new ApiGenericResponse(res);
    }
}
